

export class ProviderTrack {
    providerCode: string;
    pzoneCode: string;
    actualCode: string
    provider: string;
}